import React from 'react';
import { Truck, Lock } from 'lucide-react';
import { useUser } from '../shared/context/UserContext';

const wrapStyle = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '60vh',
  padding: 'var(--space-8)',
  textAlign: 'center',
};
const iconStyle = { color: 'var(--color-text-secondary)', marginBottom: 'var(--space-4)' };
const headingStyle = { margin: 0, color: 'var(--color-text-primary)', fontSize: '1.5rem', fontWeight: 600 };
const subStyle = { margin: 'var(--space-2) 0 0', color: 'var(--color-text-secondary)', fontSize: '0.95rem' };

export default function ToolMovesPage() {
  const { userProfile } = useUser();
  const isAdmin = userProfile?.role === 'ADMIN';

  if (!isAdmin) {
    return (
      <div style={wrapStyle}>
        <Lock size={48} style={iconStyle} />
        <h1 style={headingStyle}>You do not have access</h1>
      </div>
    );
  }

  return (
    <div style={wrapStyle}>
      <Truck size={48} style={iconStyle} />
      <h1 style={headingStyle}>Tool Moves</h1>
      <p style={subStyle}>This module is under development.</p>
    </div>
  );
}
